export function getDataMiddleware(data: any) {
	return data.data;
}
